import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    standalone: true,
    name: 'enumToDescription',
})
export class EnumToDescriptionPipe implements PipeTransform {
    transform(value: string | null | undefined): string {
        return value?.replace(/_/g, ' ').replace(/([a-z])([A-Z])/g, '$1 $2') ?? '';
    }
}
